<template>
    <div class="good_box">
        <div class="text-center"
            style="position: fixed;width:100%;height:100px;top:40%;font-size:20px;margin-top:-100px;">
            メールアドレスの変更が完了しました
        </div>
        <div style="position: fixed;top: 60%;width:100%;">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="d-grid gap-2" style="padding: 0 5px;">
                            <a type="button" class="btn btn-luna"
                                style="font-size:18px; padding:12px 0;border-color:#fff;"
                                href="/home">ホームへ</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
export default {
    data() {
        return {
        };
    },
    methods: {
        async setEmail() {
            // URLパラメータからトークンを取得
            const token = this.$route.query.token;
            
            if (!token) {
                this.$showErrorToast('トークンが指定されていません。');
                return;
            }
            
            await axios.post("/api/auth/email/mod", {
                token: token,
            })
                .then((response) => {
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401){
                        window.location.href = "/auth?logout=true"
                    }
                    else{
                        this.$showErrorToast('メールアドレスの変更に失敗しました。');
                    }
                })
        },
    },
    mounted() {
        this.setEmail()
    },
}
</script>
